import { useState, useEffect } from 'react';
import axiosInstance from '../api/axiosInstance';
import { useAuth } from '../context/AuthContext';
import { FaBell, FaBellSlash } from 'react-icons/fa';

const ThreadSubscribeButton = ({ threadId, className = "" }) => {
  const { user } = useAuth();
  const [subscribed, setSubscribed] = useState(false);
  const [loading, setLoading] = useState(false);
  const [initialLoad, setInitialLoad] = useState(true);

  useEffect(() => {
    if (user && threadId) {
      checkSubscriptionStatus();
    }
  }, [threadId, user]);

  const checkSubscriptionStatus = async () => {
    try {
      const response = await axiosInstance.get(`/threads/${threadId}/subscription-status`);
      setSubscribed(response.data.subscribed);
    } catch (error) {
      console.error('Error checking subscription status:', error);
    } finally {
      setInitialLoad(false);
    }
  };

  const handleSubscriptionToggle = async () => {
    if (!user) {
      alert('Bitte melden Sie sich an, um Threads zu abonnieren');
      return;
    }

    setLoading(true);
    try {
      if (subscribed) {
        await axiosInstance.delete(`/threads/${threadId}/subscribe`);
        setSubscribed(false);
      } else {
        await axiosInstance.post(`/threads/${threadId}/subscribe`);
        setSubscribed(true);
      }
    } catch (error) {
      const errorMsg = error.response?.data?.error || 'Fehler beim Ändern des Abonnements';
      alert(errorMsg);
      console.error('Subscription error:', error);
    } finally {
      setLoading(false);
    }
  };

  if (!user || initialLoad) {
    return null;
  }

  return (
    <button
      onClick={handleSubscriptionToggle}
      disabled={loading}
      className={`btn btn-sm ${subscribed ? 'btn-success' : 'btn-outline'} ${className}`}
      title={subscribed ? 'Thread abbestellen' : 'Thread abonnieren - Sie erhalten Benachrichtigungen bei neuen Antworten'}
    >
      {loading ? (
        <span className="loading loading-spinner loading-xs"></span>
      ) : (
        <>
          {subscribed ? <FaBell className="text-sm" /> : <FaBellSlash className="text-sm" />}
          <span className="ml-1">
            {subscribed ? 'Abonniert' : 'Abonnieren'}
          </span>
        </>
      )}
    </button>
  );
};

export default ThreadSubscribeButton;
